<template>
  <FriedTableRow :key="directory.id">
    <TypeCell icon="folder-open" :enable-min-width="false" />
    <FriedTableCell v-if="isContentPlaceholder" class="hidden-xxs-and-down">
      <FriedCheckbox
        v-tooltip="{
          content: selectableTooltip,
          delay: { show: 300, hide: 100 },
          distance: 8,
        }"
        :indeterminate="indeterminate"
        :disabled="!selectable || alreadySelected"
        :model-value="selected"
        :data-external="`directory-row-select-${directory.id}-checkbox`"
        @update:model-value="$emit('select-directory', $event, directory.id)"
      />
    </FriedTableCell>
    <DirectoryName :directory="directory" @goto-directory="$emit('goto-directory', $event)" />
    <FriedTableCell v-if="hasTagFlag" class="hidden-xs-and-down" />
    <FriedTableCell class="hidden-md-and-down" />
    <DateCell
      class="hidden-sm-and-down"
      :date="convertToISODate(directory.updatedAt)"
      :user-name="directory.user.fullName"
    />
  </FriedTableRow>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import type { DsrDirectory } from '@getaccept/lib-shared/src/library/types/dsr-directory';
import DateCell from '@getaccept/lib-shared/src/library/components/DateCell.vue';
import DirectoryName from '@getaccept/lib-shared/src/library/components/DirectoryName.vue';
import { LibraryHelper } from '@getaccept/lib-shared/src/library/helpers/library.helper';
import TypeCell from '@getaccept/lib-shared/src/library/components/TypeCell.vue';

export default defineComponent({
  name: 'DirectoryRow',
  components: {
    DirectoryName,
    DateCell,
    TypeCell,
  },
  props: {
    directory: {
      type: Object as PropType<DsrDirectory>,
      required: true,
    },
    selectable: {
      type: Boolean,
    },
    selected: {
      type: Boolean,
    },
    isContentPlaceholder: {
      type: Boolean,
    },
    indeterminate: {
      type: Boolean,
    },
    alreadySelected: {
      type: Boolean,
    },
    hasTagFlag: {
      type: Boolean,
    },
  },
  emits: ['goto-directory', 'select-directory'],
  setup(props) {
    const { t } = useI18n();
    const selectableTooltip = computed(() => {
      if (!props.selectable) {
        return t('dr_no_resources_in_directory');
      }
      if (props.alreadySelected) {
        return t('content_resource_directory_already_added');
      }
      return '';
    });
    return {
      convertToISODate: LibraryHelper.convertToISODate,
      t,
      selectableTooltip,
    };
  },
});
</script>
<style lang="scss" scoped>
.table-cell.left:first-child {
  padding-left: var(--spacing-100);
}
</style>
